import React from "react"

import Layout from "../components/layout"

const TeamPage = () => (
  <Layout title="Privacy Policy">
    <h2>Privacy Policy </h2>

    <p>
      At KUSHCO HOLDINGS, INC. (“KUSHCO HOLDINGS”), your privacy is important to
      us. This statement sets out our privacy practices with respect to the
      collection, use and disclosure of personal information on this site.
    </p>

    <p>
      Personal information is information that is personally identifiable to
      you. Personal information may include your name, e-mail address and
      mailing address, as the case may be. Visitors to this website are not
      requested to reveal any personal information. However, on a voluntary
      basis, you may provide and disclose personal information to us in using
      certain features of our site.
    </p>

    <p>
      KUSHCO HOLDINGS will never disclose, sell or lease to any third party
      other than our subsidiaries, any personal information that you provide on
      this site without your permission, unless we are required to do so by law.
    </p>

    <h3>Access </h3>

    <p>
      If you have already requested to be part of a mailing list, you may cancel
      your profile by going back to the section where you created that request
      or by contacting us using the information provided at the end of this
      privacy statement. If you have previously provided us with personal
      information and wish to verify it or have the information removed from our
      records or corrected, please contact us using the information provided at
      the end of this privacy statement.
    </p>

    <h3>Security </h3>

    <p>
      Your personal information is treated as private, confidential information
      by KUSHCO HOLDINGS and we strive to ensure that your personal information
      is protected at all times. To maintain the confidentiality of your
      personal information, this information is kept in a secure environment by
      KUSHCO HOLDINGS.
    </p>

    <p>
      However, even though KUSHCO HOLDINGS has implemented methods designed to
      ensure the protection of your personal information that are considered to
      be effective, we cannot guarantee that such information will not be lost,
      used unlawfully or modified in a fraudulent manner since no data
      transmission over the Internet can be guaranteed to be completely
      confidential. Consequently, we bear no liability for the use that may be
      made of the information by you or any third party.
    </p>

    <h3>Confidential or Proprietary Information </h3>

    <p>
      KUSHCO HOLDINGS is pleased to hear from you and welcomes your comments
      regarding KUSHCO HOLDINGS products and services. Unfortunately, you will
      understand that KUSHCO HOLDINGS does not want to receive confidential or
      proprietary information from you through our website. Please note that any
      non-personal information or material sent to KUSHCO HOLDINGS will be
      deemed NOT to be confidential. By sending KUSHCO HOLDINGS any information
      or material, you grant KUSHCO HOLDINGS an unrestricted, irrevocable
      license to use, reproduce, display, exploit, modify, transmit and
      distribute such material or information, and you also agree that KUSHCO
      HOLDINGS is free to use any ideas, concepts, know-how or techniques that
      you send us for any purpose.
    </p>

    <h3>E-mail </h3>

    <p>
      If you submit an e-mail inquiry to this site, any personal information you
      might submit at the same time will only be used by KUSHCO HOLDINGS
      employees or its subsidiaries that who need to have access to it in order
      to respond to your inquiry.
    </p>

    <h3>Changes </h3>

    <p>
      KUSHCO HOLDINGS reserves the right to change this privacy statement as it
      sees fit and without prior notice. However, we will ensure that any change
      to this statement is in compliance with privacy laws in effect and is
      posted on this page.
    </p>

    <h3>External Links </h3>

    <p>
      This site may contain links that take you to other websites. This privacy
      statement does not extend to the data collection practices of third
      parties and KUSHCO HOLDINGS does not assume any responsibility for the
      privacy practices, policies or actions of third parties. You should read
      the individual privacy policies of such sites and make an informed
      decision as to whether or not you wish to use these sites based on their
      privacy practices
    </p>

    <h3>Find Out More </h3>

    <p>
      If you have any comments, questions or complaints regarding KUSHCO
      HOLDINGS privacy statement or practices, please contact us using the
      information found on
      [ir.kushco.com/company-information/contacts](https://ir.kushco.com/company-information/contacts),
      or in writing at KUSHCO HOLDINGS, 6261 Katella Ave, Suite 250, Cypress CA
      90630.
    </p>

    <strong>
      <em>Last Updated: Sept 3, 2019</em>
    </strong>
  </Layout>
)

export default TeamPage
